import { Badge, Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

import AdditionalBreakTimer from 'containers/EmployeeTimeClock/ClockedInDetail/AdditionalBreakTimer';
import { secondsToTime, remainderTimeInSeconds } from 'containers/EmployeeTimeClock/shared/helper';
import { useTimeClockStore } from 'store/useTimeClockStore';

interface IProps {
  activeBreak: any;
  onBreakEnd: () => void;
  showAdditionalBreakTime: boolean;
  setShowAdditionalBreakTime: (value: boolean) => void;
}

const ActiveBreakTimer: React.FC<IProps> = ({
  activeBreak,
  onBreakEnd,
  showAdditionalBreakTime,
  setShowAdditionalBreakTime,
}) => {
  const timeClockDetails: any = useTimeClockStore(state => state.timeClock);

  const remainderTime = remainderTimeInSeconds({
    breakStart: activeBreak?.startLocal,
    timezone: timeClockDetails?.userTimezone,
    breakLength: activeBreak?.break_type?.length,
  });

  const onCountdownComplete = () => {
    if (activeBreak?.break_type?.end_break_automatically) {
      onBreakEnd();
    } else {
      setShowAdditionalBreakTime(true);
    }
  };

  const renderTime = (dimension: any, time: any) => {
    if (time === '00:00') {
      return <></>;
    }

    return (
      <Box display="flex" alignItems="center" flexDirection="column" flexWrap="wrap">
        <Heading as="h2">{time}</Heading>
        <Text textAlign="center">{dimension} remaining</Text>
        <Text width="80%" textAlign="center">
          of
        </Text>
        <Text width="80%" textAlign="center">
          {activeBreak?.break_type?.length / 60} minutes
        </Text>
      </Box>
    );
  };

  const renderBreakMessage = () => {
    if (activeBreak?.break_type?.end_break_automatically) {
      return 'This break will end automatically.';
    }

    if (showAdditionalBreakTime && activeBreak?.break_type?.no_set_length) {
      return 'No time set for this break.\n It will continue until you end it manually.';
    }

    if (showAdditionalBreakTime && !activeBreak?.break_type?.no_set_length) {
      return 'You are on an Extra Break.\n This break will continue until you end it manually.';
    }

    if (!showAdditionalBreakTime && !activeBreak?.break_type?.no_set_length) {
      return 'This break will continue until you end it manually.';
    }

    return null;
  };

  return (
    <>
      <Text fontSize="xl" fontWeight="semibold" mt="5">
        {activeBreak?.break_type?.name}
        <Badge ml="2" colorScheme={activeBreak?.break_type?.paid ? 'green' : 'orange'}>
          {activeBreak?.break_type?.paid ? 'Paid' : 'Unpaid'}
        </Badge>
      </Text>

      <Box mb="10" textAlign="center">
        <Box display="flex" flexDirection="column" alignItems="center" position="relative" width="100%" mt={6} mb="8">
          <CountdownCircleTimer
            isPlaying={true}
            size={240}
            strokeWidth={10}
            colors={[['#004777', 0.33]]}
            duration={activeBreak?.break_type?.length}
            initialRemainingTime={remainderTime}
            onComplete={onCountdownComplete}
          >
            {({ remainingTime }) => renderTime('minutes', secondsToTime(remainingTime || 0, ''))}
          </CountdownCircleTimer>
          {showAdditionalBreakTime && <AdditionalBreakTimer breakData={activeBreak} />}
        </Box>

        <Text>{renderBreakMessage()}</Text>
      </Box>
    </>
  );
};
export default ActiveBreakTimer;
